import { getCurrentRootDomain } from "./getCurrentRootDomain";

/**
 * Domain attribute for cookies that must follow the user onto the truegate
 * checkout subdomain (`t.`): the root host of the current origin, so
 * `tixu.ai` and `t.tixu.ai` share them. Undefined on the server.
 */
export const getCookieDomain = (): string | undefined => {
    if (typeof window === "undefined") return undefined;
    try {
        const root = getCurrentRootDomain();
        if (!root) return undefined;
        return new URL(root).hostname;
    } catch {
        return undefined;
    }
};
